/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Logger } from '@app/core';
import { ClientsService } from '@app/clients/clients/clients.service';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ApiQuery } from '@app/core/http/api-query';
import { Client } from '@app/clients/clients/client.model';
import { ClientsFormService } from '@app/clients/clients/clients-form.service';
import { environment } from '@env/environment';

const log = new Logger();

@Component({
  selector: 'app-client-finder',
  templateUrl: './client-finder.component.html',
  styleUrls: ['./client-finder.component.scss'],
})
export class ClientFinderComponent implements OnInit {
  form: FormGroup;
  @Input() data: object = {};
  @Input() multiple: boolean;
  clientsResponse: PaginatedResponse;
  gridData: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  selectedClients: Array<Client> = [];
  env = environment;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private clientsService: ClientsService,
    private clientsFormService: ClientsFormService
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      keywords: [null],
      exact: [false],
      // company_name: [null],
      // phone: [null],
      // email: [null]
    });
    this.form.patchValue(this.data);
    if (Object.keys(this.data).length > 0 && !Object.values(this.data).every((x) => x === null)) {
      this.loadData();
    }
  }

  /**
   * Затваря модала и праща обратно данните от резултата (всичките селектнати client)
   */
  save(): void {
    this.modal.close(this.selectedClients);
  }

  selectClient(client: Client): void {
    this.deselectAll();
    this.clientCheckboxChange(client);
    this.save();
  }

  loadData(state: DataStateChangeEvent = null): void {
    log.debug('find ', this.form.value);

    let searchStr = this.form.get('keywords').value;

    if (this.form.get('exact').value && this.form.get('keywords').value) {
      searchStr = '"' + searchStr + '"';
    }

    this.state = state;
    this.apiQuery.setDataSetFilters(state).addFilters({ active: true }).addIncludes('country', 'city');

    this.clientsService.search(searchStr, this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.clientsResponse = response;
      this.gridData = response.getGridData();
    });
  }

  /**
   * Премахва всички селектнати clients
   */
  deselectAll(): void {
    this.selectedClients = [];
  }

  /**
   *  Проверява дали client-a е селектнат
   * @param id ID-то на клиента
   */
  isClientSelected(id: number): boolean {
    return !!(
      this.selectedClients &&
      this.selectedClients.length > 0 &&
      this.selectedClients.find((client: Client) => client.id === id)
    );
  }

  /**
   * При промяна на чекбокс добавя или премахва от масива със селектнатите clients
   * @param client Client обект
   */
  clientCheckboxChange(client: Client): void {
    if (this.isClientSelected(client.id)) {
      this.selectedClients.splice(this.findClientIndex(client.id), 1);
    } else {
      this.selectedClients.push(new Client().deserialize(client));
    }
  }

  test(logg: any) {
    log.debug(logg);
    log.debug('selectec', this.selectedClients);
  }

  edit(client: Client) {
    this.clientsFormService.open(client).then(
      (res) => {
        this.loadData(this.state);
      },
      () => {}
    );
  }

  addNewClient() {
    this.clientsFormService.open().then(
      (response) => {
        this.form.reset();
        this.loadData();
      },
      (err) => {
        log.info('modal closed');
      }
    );
  }

  /**
   *  Помощна функция, която намира client-a по ID и връща индекса му
   *  Като indexOf, но работи
   * @param client Client или Client.id
   */
  private findClientIndex(client: any): number {
    return this.selectedClients.indexOf(
      this.selectedClients.find((c: Client) => {
        if (client.id) {
          return c.id === client.id;
        } else if (client) {
          return c.id === client; // ако е подадено директно ID-то на client-a без да е в обект
        }
        return false;
      })
    );
  }
}
